<template>
    <div
        class="form-group has-effect"
        :class="[
            { 'is-invalid': invalidPhone },
            { 'no-icon': !invalidIcon }
        ]"
    >
        <div class="has-effect-input">
            <input
                id="phone"
                type="text"
                class="form-control"
                :class="[
                    { 'has-content': phone },
                    { 'is-invalid': invalidPhone }
                ]"
                :readonly="readonly"
                v-model="phone"
                @input="acceptPhone"
                v-click-outside="isPhoneLengthValid"
            />
            <label class="form-label">
                <span v-if="placeholder" v-text="placeholder" />
                <span v-if="required" v-text="'*'" class="text-danger pl-1" />
            </label>
        </div>
        <div v-if="invalidPhone" class="invalid-feedback">
            {{ invalidFeedback }}
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            phone: null
        }
    },
    props: {
        placeholder: {
            type: String,
            required: false
        },
        invalidPhone: {
            type: Boolean
        },
        phoneValue: {
            type: String,
            required: false
        },
        readonly: {
            type: Boolean,
            default: false
        },
        invalidIcon: {
            type: Boolean,
            default: true
        },
        required: {
            type: Boolean,
            default: false
        },
        invalidFeedback: {
            type: String,
            default: 'Numer telefonu jest zbyt krótki'
        }

    },
    watch: {
        phoneValue: {
            immediate: true,
            handler() {
                if (!this.phoneValue) {
                    this.phone = this.phoneValue
                }
            }
        }
    },
    methods: {
        acceptPhone() {
            const value = this.phone
                .replace('+48 ', '')
                .replace(/\D/g, '')
                .match(/(\d{0,3})(\d{0,3})(\d{0,3})/)
            this.phone =
                this.phone === '+48 '
                    ? null
                    : '+48 ' +
                      (!value[2]
                          ? value[1]
                          : value[1] +
                            '-' +
                            value[2] +
                            (value[3] ? '-' + value[3] : ''))
            if (this.phone?.length === 4) {
                this.phone = null
            }
            this.$emit('onChange', this.phone)
            if (this.phone?.length === 15 && this.invalidPhone) {
                this.$emit('setInvalidPhoneValue', false)
            }
        },
        isPhoneLengthValid() {
            this.$emit(
                'setInvalidPhoneValue',
                this.phone?.length > 0 && this.phone?.length < 15
            )
        },
        setPhoneFormat() {
            return `${this.$options.filters.formatPhone(this.phoneValue)}`
        }
    },
    created() {
        const formatValue = this.setPhoneFormat()
        this.phone = formatValue === '-' ? null : formatValue
    }
}
</script>
